module.exports = __webpack_public_path__ + "front/img/edm-agenda.1e56f33a.png";